import React, { useState } from 'react'
import AdminSearchBarHeader from '../component/AdminSearchBarHeader'
import { Avatar, Button, Card, Col, Image, Row, Spin } from 'antd'
import { getAdminDetail } from '../../../controller/localStroageHandler'

const Profile = () => {
  const [loading,setLoading]=useState(false)
  const userdetail=getAdminDetail()
  return (
    <div className='w-100 h-100 p-4 bg-light'>
      <AdminSearchBarHeader search={"search"} setSearch={() => { }} />
      <Row align={'middle'} className='mt-4 mb-4'>
        <Col span={24} className='fs-6 fw-semibold'>
          Profile
        </Col>
      </Row>
      <Spin spinning={loading}>
        <Row gutter={[12, 15]}>
          <Col xl={8} lg={8} md={10} sm={12} xs={24} className=''>
            <div className=' h-100'>
              <Card className='text-center h-100 d-flex justify-content-center align-items-center'>
                <div className=' h-100 w-100 d-flex flex-column  gap-2 align-items-center '>
                  <Avatar
                    style={{
                      backgroundColor: '#b2d8a7',
                      verticalAlign: 'middle',
                    }}
                    size='large'
                  >
                   {userdetail?.firstName?.[0]}{userdetail?.lastName?.[0]}
                  </Avatar>
                  <div className='d-flex flex-column'>
                    <span className='text-black fw-semibold fs-5'>
                      {userdetail?.firstName} {userdetail?.lastName}
                    </span>
                   
                  </div>
                 
                </div>
              </Card>
            </div>
          </Col>
          <Col xl={16} lg={16} md={14} sm={12} xs={24} className=''>
            <div className=' h-100'>
              <Card className='h-100'>
                <div className='d-flex flex-column gap-2'>
                  <div className='d-flex justify-content-between align-items-center fw-semibold'>
                    <span className='text-black'>Email ID</span>
                    <span className='text-muted'>
                     {userdetail?.email}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center fw-semibold'>
                    <span className='text-black'>Phone No.</span>
                    <span className='text-muted'>
                    {userdetail?.phoneNo}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center fw-semibold'>
                    <span className='text-black'>Role</span>
                    <span className='text-muted'>
                    {userdetail?.role}
                    </span>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
          <Col xl={8} lg={8} md={10} sm={12} xs={24} className=''>
            <div className=' h-100'>
            <Card className='h-100'>
                <div className='w-100 border-bottom pb-2 fs-5 fw-bold'>
                  Logo
                </div>
                <div className='mt-3'>
                <div className='d-flex flex-column fw-semibold gap-2'>
                    <span className='d-flex justify-content-center flex-wrap gap-2'>
                    <Image src={userdetail?.organization_id?.logo||Image?.logo} alt='logo' className='logo' preview={false} width={200}/>
                    </span>
                  </div>
                </div>
              </Card>
              {/* <Card className=' h-100'>
                <div className='d-flex flex-column fw-semibold gap-2'>
                    <span className='text-black'>Logo</span>
                    <span className='d-flex flex-wrap gap-2'>
                    <Image src={userdetail?.organization_id?.logo} alt='logo' preview={false} width={200}/>
                    </span>
                  </div>
              </Card> */}
            </div>
          </Col>
          <Col xl={16} lg={16} md={14} sm={12} xs={24} className=''>
            <div className=' h-100'>
              <Card className='h-100'>
                <div className='w-100 border-bottom pb-2 fs-5 fw-bold'>
                  Organization
                </div>
                <div className='mt-3'>
                <div className='d-flex flex-column gap-2'>
                  <div className='d-flex justify-content-between align-items-center fw-semibold'>
                    <span className='text-black'>Organization Name</span>
                    <span className='text-muted'>
                     {userdetail?.organization_id?.organizationName}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center fw-semibold'>
                    <span className='text-black'>CIN No</span>
                    <span className='text-muted'>
                     {userdetail?.organization_id?.cinNo}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center fw-semibold'>
                    <span className='text-black'>Industry</span>
                    <span className='text-muted'>
                     {userdetail?.organization_id?.industry}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between align-items-center fw-semibold'>
                    <span className='text-black'>Address</span>
                    <span className='text-muted'>
                     {`${userdetail?.organization_id?.address}, ${userdetail?.organization_id?.city}, ${userdetail?.organization_id?.state}` }
                    </span>
                  </div>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Spin>
    </div>
  )
}

export default Profile